import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../services/apiService';
import './LoginPage.css';

// Trigger frontend rebuild with correct backend URL configuration
const LoginPage = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Prevent submission if fields are empty
    if (!username.trim() || !password.trim()) {
      setError('Please enter both username and password.');
      return;
    }
    
    setError('');
    setIsLoading(true);

    try {
      const response = await login(username, password);

      if (response.success && response.data) {
        // New API returns: { success: true, message: "...", data: { access_token, refresh_token, user: {...} } }
        await onLogin({
          accessToken: response.data.access_token,
          refreshToken: response.data.refresh_token,
          user: response.data.user
        });
        navigate('/chatbot');
      } else {
        setError(response.message || response.error || 'Login failed. Please try again.');
      }
    } catch (err) {
      setError('Network error. Please check your connection.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-illustration">
          <img 
            src="/images/jj_illus_character_large.png" 
            alt="Jeeves Junior Character" 
            className="login-character"
          />
          <div className="greeting-text">
            <h2 className="greeting-title">Greetings!</h2>
            <p className="greeting-subtitle">Got questions? Please log in to begin.</p>
          </div>
        </div>
        
        <div className="login-form-container">
          <div className="login-card">
            <div className="login-card-header">
              <img 
                src="/images/jj_logo_loginscreen.png" 
                alt="Jeeves Junior" 
                className="login-logo"
              />
              <p className="login-subtitle">Accounts are available by invitation only</p>
            </div>
            
            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <label htmlFor="username" className="form-label">Username</label>
                <input
                  type="text"
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="form-input"
                  required
                  disabled={isLoading}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="password" className="form-label">Password</label>
                <div className="password-input-container">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="form-input"
                    required
                    disabled={isLoading}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="password-toggle"
                    disabled={isLoading}
                  >
                    <img 
                      src="/images/jj_icon_showpassword.png" 
                      alt="Show/Hide Password" 
                      className="password-icon"
                    />
                  </button>
                </div>
              </div>
              
              {error && <div className="error-message">{error}</div>}
              
              <button 
                type="submit" 
                className="login-button"
                disabled={isLoading}
              >
                {isLoading ? 'LOGGING IN...' : 'LOG IN'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage; 